import createNewBudgetDialogTemplate from './createNewBudgetDialog.template.html';

/*****************************************************************************
 * Service: createNewBudgetDialog */
/**
 * @ngdoc  service
 * @module budgets
 * @name   budgets.service:createNewBudgetDialog
 * @description
 * Utility to show a dialog for adding or editing amounts for an account
 *****************************************************************************/
/* @ngInject */ export function createNewBudgetDialog($uibModal) {
  /***************************************************************************
   * Properties
   ***************************************************************************/
  /** Self reference. */ var mThis = this;

  /***************************************************************************
   * show */
  /**
   * @ngdoc     method
   * @module    budgets
   * @methodOf  budgets.service:createNewBudgetDialog
   * @param     {object}  availableBudgets  Budget years that can be created
   * @param     {object}  existingBudgets   Budgets that are already created
   * @description
   * Show the modal dialog for editing a budget.
   ***************************************************************************/
  mThis.show = function (availableBudgets, existingBudgets) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: createNewBudgetController,
      resolve: {
        availableBudgets: function () {
          return availableBudgets;
        },
        existingBudgets: function () {
          return existingBudgets;
        }
      },
      size: 'sm',
      template: createNewBudgetDialogTemplate
    }).result;
  };
}

/*****************************************************************************
 * Controller: createNewBudgetController */
/**
 * @ngdoc   controller
 * @module  budgets
 * @name    budgets.controller:createNewBudgetController
 * @description
 * Creates a dialog for creating new budgets. When creating a new budget the
 * user is given the option to copy information from an existing budget.
 *****************************************************************************/
/* @ngInject */ function createNewBudgetController(
  $scope,
  availableBudgets,
  existingBudgets,
  Tools
) {
  $scope.availableBudgets = availableBudgets;
  $scope.existingBudgets = existingBudgets;

  /***************************************************************************
  * close
  /**
  * Closes the dialog and passes the selection information back to the 
  * controller promise.
  ***************************************************************************/
  $scope.close = function () {
    $scope.$close($scope.req);
  };
}
